import {useMutation, useQueryClient} from '@tanstack/react-query';

import {refreshTopicEvents} from '../api';
import {QUERY__TOPIC, QUERY__TOPIC_EVENTS} from '../queryKeys';

export const useRefreshTopicEvents = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refreshTopicEvents,
    onSuccess: async (_, topicSlug) => {
      await Promise.all([
        queryClient.invalidateQueries({queryKey: [QUERY__TOPIC, topicSlug]}),
        queryClient.invalidateQueries({
          queryKey: [QUERY__TOPIC_EVENTS, {topicId: topicSlug}],
        }),
        queryClient.invalidateQueries({queryKey: ['sportMatch']}),
      ]);
    },
  });
};
